import React, { Component } from 'react';
import { Button, Row, Col, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import ChatsService from '../../controllers/ChatController';
import i18next from 'src/i18next';
import Toastr from 'src/components/utils/toastr';
class ConversationSummary extends Component {

    constructor(props) {
        super(props)

        this.state = {
            language: navigator.language.substring(0, 2),
            sentiment: "neutral",
            summary: ""
        }

        this.setSummary = this.setSummary.bind(this);
        this.toastrRef = React.createRef();
    }

    componentDidUpdate(prevProps, prevState) {

        if (!prevProps.show && this.props.show) {
            this.setLoading(true);
            ChatsService.getSummary(
                {
                    guid: this.props.guid,
                    summaryLanguage: i18next.language || window.localStorage.i18nextLng,
                    id: this.props.id,
                    channel: this.props.channel,
                    outbound: this.props.outbound
                }
                , this.setSummary);
        }
    }

    setLoading(value) {
        this.setState({
            loading: value
        });
    }

    setSummary(data) {
        if (data != null) {
            this.setState({
                language: data.lastLanguage,
                sentiment: data.clientSentiment,
                summary: data.chatSummary,
                loading: false
            });
        } else {
            this.setState({
                loading: false
            });

            this.toastrRef.current.setType("error");
            this.toastrRef.current.setMessage(this.props.t("error"));
            this.toastrRef.current.show();

            this.props.toggleModal();
        }
    }

    render() {
        return (
            <>
                <Modal show={this.props.show} onHide={this.props.toggleModal} onShow={this.showModal} size="lg">
                    <BlockUi tag="div" blocking={this.state.loading} color="#009ef7" message={this.props.t("pleasewait")}>
                        <Modal.Header >
                            <Modal.Title><FontAwesomeIcon icon={duotone("square-list")} /> {this.props.t("summary")}</Modal.Title>
                            <OverlayTrigger
                                placement="left"
                                delay={{ show: 250, hide: 400 }}
                                overlay={<Tooltip style={{ position: "fixed" }}>
                                    {this.props.t("close")}
                                </Tooltip>}>
                                <Button onClick={this.props.toggleModal} className='float-end'><FontAwesomeIcon icon={solid('xmark')} /></Button>
                            </OverlayTrigger>
                        </Modal.Header>
                        <Modal.Body>
                            <Row>
                                <Col lg={1}><FontAwesomeIcon size='lg' icon={duotone('globe')} /></Col>
                                <Col lg={1}><h5>{this.props.t("language")}</h5></Col>
                            </Row>
                            <Row>
                                <Col lg={1}></Col>
                                <Col><span className="opacity-75 fs-6">{this.props.t(this.state.language)}</span></Col>
                            </Row>
                            <Row className='mt-5'>
                                <Col lg={1}>
                                    {
                                        this.state.sentiment === 'positive' &&
                                        <FontAwesomeIcon size='lg' icon={duotone('face-smile')} className='text-success' />
                                    }
                                    {
                                        this.state.sentiment === 'neutral' &&
                                        <FontAwesomeIcon size='lg' icon={duotone('face-meh')} className='text-warning' />
                                    }
                                    {
                                        this.state.sentiment === 'negative' &&
                                        <FontAwesomeIcon size='lg' icon={duotone('face-angry')} className='text-danger' />
                                    }
                                </Col>
                                <Col lg={2}><h5>{this.props.t("sentiment")}</h5></Col>
                            </Row>
                            <Row>
                                <Col lg={1}></Col>
                                <Col><span className="opacity-75 fs-6">{this.props.t(this.state.sentiment)}</span></Col>
                            </Row>
                            <Row className='mt-5'>
                                <Col lg={1}><FontAwesomeIcon size='lg' icon={duotone('square-list')} /></Col>
                                <Col lg={1}><h5>{this.props.t("summary")}</h5></Col>
                            </Row>
                            <Row>
                                <Col lg={1}></Col>
                                <Col><p className="opacity-75 fs-6">{this.state.summary}</p></Col>
                            </Row>
                        </Modal.Body>
                    </BlockUi>
                </Modal>
                <Toastr ref={this.toastrRef} />
            </>)
    }
}

export default withTranslation()(ConversationSummary);